import IAttachmentInterface from "../interfaces/IAttachmentInterface";
import Network from "../network/network";
import { EntityTypeId } from "../util/EntityTypeId";
import Logger, { Loglevel } from "../util/Logger";

export default class AttachementService {
    private SERVICE_NAME = "AttachementService";
    private API_ROUTE = "Attachment/Upload";

    private readonly network: Network;
    private readonly logger: Logger;

    constructor(network: Network, logger: Logger) {
        this.network = network;
        this.logger = logger;
    }

    public uploadAttachments = async (entityId: string, entityTypeId: EntityTypeId, files: FormData): Promise<void> => {
        try {
            // The multipart form goes through sendForm, so a refused upload is thrown like every other
            // request. The caller cannot act on it, hence the log: without it a rejected upload left the
            // attachments missing on the entity and said nothing.
            await this.network.sendForm(`${Network.APIBaseURL}${this.API_ROUTE}?entityId=${entityId}&entityTypeId=${entityTypeId}`, files);
        } catch (e) {
            this.logger.log(Loglevel.Error, `${this.SERVICE_NAME}: Unable to upload attachement`, e);
        }
    };

    public getAttachments = async (entityUuid: string, entityTypeId: EntityTypeId): Promise<IAttachmentInterface[]> => {
        const attachments = await this.network.requestJsonPublicApi(`Attachment/GetAttachments?entityId=${entityUuid}&entityTypeId=${entityTypeId}`);
        return attachments as IAttachmentInterface[];
    };

    public deleteAttachments = async (entityUuid: string, entityTypeId: EntityTypeId, attachments: IAttachmentInterface[]): Promise<void> => {
        try {
            await Promise.all(
                attachments.map(async a => {
                    await this.network.sendPublicApi(`Attachment/Delete?entityId=${entityUuid}&entityTypeId=${entityTypeId}`, { Id: a.Id });
                })
            );
        } catch (e) {
            // The caller does not await this, so a refusal would end up as an unhandled rejection - and a
            // rejected delete leaves the attachment on the entity, which is worth a line in the log.
            this.logger.log(Loglevel.Error, `${this.SERVICE_NAME}: Unable to delete attachement`, e);
        }
    };
}
